module.exports = __webpack_public_path__ + "static/media/7-days.30e7310a.svg";